import { Trans } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';
import { Link } from '@/components/ui/link';

import { useDensityValidation } from '../model/use-density-validation';

interface DensityValidationAlertProps {
  weight?: number;
  volume?: number;
  isViewMode?: boolean;
}

export function DensityValidationAlert({ weight, volume, isViewMode = false }: DensityValidationAlertProps) {
  const validation = useDensityValidation({
    weight,
    volume,
    enabled: !isViewMode
  });

  if (validation.isValid || !validation.errorMessage) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <AlertDescription className="inline">
        {validation.errorMessage}
        <br />
        <Trans
          i18nKey="gen.density.problems.desc"
          defaultValue="Please check your weight and volume values. <a>Cargo dimension calculator</a>"
          components={{
            a: (
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href="https://rita-manual.logcluster.org/en/cargo-dimension-calculator"
              />
            )
          }}
        />
      </AlertDescription>
    </Alert>
  );
}
